import script from "./HrTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTooltip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
